import { init } from "../init-streaming";
import { SearchResultsPage } from "../pages/search/search";
init(SearchResultsPage);
